export enum TipoPagamentoViagem {
    Pix = 1,
    CartaoCredito = 2,
  }